export const columns = [
  {
    name: 'Subscription',
    customClassNames: 'col-20',
  },
  {
    name: 'Billing account',
    customClassNames: 'col-10',
  },
  {
    name: 'Billing address',
    customClassNames: 'col-10',
  },
  {
    name: 'Payment method',
    customClassNames: 'col-10',
  },
  {
    name: 'Usage',
    customClassNames: 'col-10',
  },
  {
    name: 'Last billed',
    customClassNames: 'col-10',
  },
  {
    name: 'Next bill/ Expiry',
    customClassNames: 'col-10',
  },
  {
    name: 'Billing cycle',
    customClassNames: 'col-10',
  },
  {
    name: 'Pricing eligibility',
    customClassNames: 'col-10',
  },
];
